import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Bare application root — all chrome lives in routed components, mirroring the privaci admin root.
 * The shell is a routed layout (`./shell`), loaded only for in-shell routes, so `/login` and
 * `/ingen-adgang` render standalone without the sidebar, appbar or user chip.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<router-outlet />',
})
export class App {}
